/**
 * @generated SignedSource<<63e3dead23caa38ef838fc9864ccdce1>>
 * @relayHash 43575548a2954858e524a98dc3e35a97
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 43575548a2954858e524a98dc3e35a97

import { ConcreteRequest } from 'relay-runtime';
export type useForecastFileUploadQuery$variables = Record<PropertyKey, never>;
export type useForecastFileUploadQuery$data = {
  readonly forecastFileUpload: {
    readonly id: string;
    readonly uploadAt: string | null;
    readonly uploadBy: string | null;
  };
};
export type useForecastFileUploadQuery = {
  response: useForecastFileUploadQuery$data;
  variables: useForecastFileUploadQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ForecastFileUpload",
    "kind": "LinkedField",
    "name": "forecastFileUpload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uploadBy",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uploadAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useForecastFileUploadQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useForecastFileUploadQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "43575548a2954858e524a98dc3e35a97",
    "metadata": {},
    "name": "useForecastFileUploadQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "58c76c799d2f20a735a39579ccdabc7d";

export default node;
